(function () {
	const initProductAccordion = () => {
		$(".product-collapsible-row__title").off('click').on('click', function () {
			if (!$(this).hasClass("active")) {
				$(".product-collapsible-row__title.active").removeClass("active");
				$(this).addClass("active");
				$(".product-collapsible-row__description").stop().slideUp(300);
				$(this)
					.siblings(".product-collapsible-row__description")
					.eq($(this).index())
					.stop()
					.slideDown(300);

					const autoNavigation = $(this).data("autoNavigation");
					if (autoNavigation && window.innerWidth < 990) {
						setTimeout(() => {
							const $headerWrapper = $(".header-wrapper");
							const headerWrapper = $headerWrapper.length
								? $headerWrapper.height()
								: 0;

							const $sectionAnnouncement = $(".section-announcement");
							const sectionAnnouncement = $sectionAnnouncement.length
								? $sectionAnnouncement.height()
								: 0;
							const $countdownTimerBar = $(".countdown-timer-bar");
							const countdownTimerBar = $countdownTimerBar.length
								? $countdownTimerBar.height()
								: 0;

							const position = $(this).offset().top - headerWrapper - sectionAnnouncement - countdownTimerBar;

							window.scrollTo({
								top: position,
								behavior: "smooth"
							});
						}, 400);
					}
			} else {
				$(this).removeClass("active");
				$(this).siblings(".product-collapsible-row__description").stop().slideUp(300);
			}
		});
	};

	const initDescriptionAccordion = () => {
		const $root = $("[data-product-desc-accordion]");
		if (!$root.length) return;

		$root.find(".product-desc-accordion__title").off("click.descAccordion").on("click.descAccordion", function () {
			const $btn = $(this);
			const $item = $btn.closest(".product-desc-accordion__item");
			const $accordion = $btn.closest("[data-product-desc-accordion]");
			const $content = $btn.siblings(".product-desc-accordion__content");

			if ($btn.hasClass("active")) {
				$btn.removeClass("active").attr("aria-expanded", "false");
				$item.removeClass("is-open");
				$content.stop().slideUp(300, function () {
					$content.attr("hidden", true);
				});
				return;
			}

			$accordion.find(".product-desc-accordion__title.active").each(function () {
				const $other = $(this);
				$other.removeClass("active").attr("aria-expanded", "false");
				$other.closest(".product-desc-accordion__item").removeClass("is-open");
				$other.siblings(".product-desc-accordion__content").stop().slideUp(300, function () {
					$(this).attr("hidden", true);
				});
			});

			$btn.addClass("active").attr("aria-expanded", "true");
			$item.addClass("is-open");
			$content.removeAttr("hidden").stop().slideDown(300);
		});
	};

	const initAll = () => {
		initProductAccordion();
		initDescriptionAccordion();
	};

	document.addEventListener("shopify:section:load", function () {
		initAll();
	});

	initAll();
})();
